export default __webpack_public_path__ + "static/media/46_jewellery.9ac84d43.JPG";